// extracted by mini-css-extract-plugin
module.exports = {"step":"styles_step__2j62H","iconStep":"styles_iconStep__3SrHz","selectedStep":"styles_selectedStep__3LKmx","passedStep":"styles_passedStep__1E9EX"};